export const GET_CATEGORIES_SUCCESS = 'GET_CATEGORIES_SUCCESS';
export const GET_SUBCATEGORY_FILTERS = 'GET_SUBCATEGORY_FILTERS';
export const GET_OBJECTS = 'GET_OBJECTS';